export const LIST_ALERTS_MANAGEMENT = `
  query ListAlertsManagement($filter: ListAlertsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    workflow {
      listAlerts(filter: $filter, page: $page, orderBy: $orderBy) {
        items {
          id
          name
          routineId
          routineName
          assetName
          groupName
          productName
          assetAlerts
          lastAlertDate
          nextAlertDate
          createdAt
          disabled
        }
        count
        offset
        limit
      }
    }
  }
`;
